import { Injectable } from '@angular/core';
import { Statistics } from 'app/trello/models/board-summary';
import { LabelledValues, OverdueChartData } from 'app/trello/models/charts';
import { StatisticsAggregator } from 'app/trello/utility/statistics-aggregator';
import { StatisticsExtractor } from 'app/trello/utility/statistics-extractor';
import { StructureTransformer } from 'app/trello/utility/structure-transformer';

@Injectable({
  providedIn: 'root'
})
export class OverdueChartDataAggregator {

  constructor(
    private readonly statisticsAggregator: StatisticsAggregator,
    private readonly statisticsExtractor: StatisticsExtractor,
    private readonly statisticsTransformer: StructureTransformer,
  ) {
  }

  public aggregate(
    stats: Statistics,
    aggregationLevel: 'day' | 'week' | 'month' = 'day'
  ): OverdueChartData {

    const totalOverdueCardsData =
      this.statisticsAggregator.aggregateCountDistinct(
        stats.overdue.total.day || {},
        aggregationLevel,
      );

    const overdueAtStart =
      this.statisticsExtractor.aggregateUniqueCount(
        stats.overdue.total.start || {},
      );

    const becameOverdueDuringPeriod =
      this.statisticsExtractor.aggregateUniqueCount(
        stats.overdue.becameOverdue || {},
      );

    const totalOverdueVsBecameOverdue = {

      labels: [
        'Overdue at Start',
        'Became Overdue During Period',
      ],
      values: [
        overdueAtStart,
        becameOverdueDuringPeriod,
      ],

    } as LabelledValues;

    const overdueBecameOverdueData =
      this.statisticsAggregator.aggregateCountDistinct(
        stats.overdue.becameOverdue || {},
        aggregationLevel,
      );

    const overdueDurationData =
      this.statisticsAggregator.aggregateDuration(
        this.statisticsTransformer.collectInnerValues2D(stats.overdue.duration) || {},
        aggregationLevel,
      );

    return {
      totalCards: totalOverdueCardsData,
      totalOverdueVsBecameOverdue: totalOverdueVsBecameOverdue,
      becameOverdue: overdueBecameOverdueData,
      duration: overdueDurationData,
    };
  }

}
